import React from 'react'
import { Controller } from 'react-hook-form'
import { FormFeedback, Input, Label } from 'reactstrap'
import {yupResolver} from '@hookform/resolvers/yup'

const InputPhone = ({
  label,
  options,
  control,
  errors
}) => {
  return (
    <React.Fragment>
      <Label className="form-label" for={options.id}>
        {label}
      </Label>
      <Controller
        id={options.id}
        name={options.name}
        control={control}
        render={({ field }) => (
          <Input
            invalid={errors[options.name] && true}
            {...field}
            placeholder=""
            type="tel"
            disabled={options?.disabled}
            onChange={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, '')
              if (e.target.value[0] === '0') return
              if (e.target.value.length <= 8) {
                field.onChange(e)
              }
            }}
          />
        )}
      />
      {errors[options.name] && (
        <FormFeedback>{errors[options.name]?.message}</FormFeedback>
      )}
    </React.Fragment>
  )
}

export default InputPhone
